import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Typography, Paper,IconButton,Divider,ListItemText, ListItem, List, ListItemAvatar, ListItemSecondaryAction,Tooltip} from '@material-ui/core';
import { AddCircleOutline as AddCircleOutlineIcon, Edit as EditIcon, Warning as WarningIcon} from '@material-ui/icons';
import moment from 'moment';
import 'moment/locale/ru';

import { StaffName, StaffAvatar, SheduleDayHeader } from '..';

const useStyles = makeStyles(theme => ({
  root: {
    border: '1px solid',
    borderColor:  'rgba(255, 255, 255, 0.23)',
    borderRadius: theme.shape.borderRadius,
    marginRight: '5px',
    padding: '3px',
  },
  footer: {
    display: 'flex',  
  },
  addbutton: {
    marginLeft: 'auto',
  },
  warningIcon: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(2)
  }
 
}));

const checkSchedule = (data, tz) => {
  const mDay = new Array(data.length);
  for (var i=0;i<data.length;i++) {
    mDay[i] = new Array(1440);
    const d1=(moment.unix(data[i].d1).utcOffset(tz)-moment.unix(data[i].d1).utcOffset(tz).startOf('day'))/60000;
    const d2=(moment.unix(data[i].d2).utcOffset(tz)-moment.unix(data[i].d2).utcOffset(tz).startOf('day'))/60000-1;
    for (var j=d1;j<=d2;j++) {
      mDay[i][j]=data[i].r?0.1:1;  
    }
  }

  for (j=0;j<1440;j++) {
    let sum = 0;
    for (i=0;i<mDay.length;i++) {
      sum = sum + (mDay[i][j]||0);
    }
    if (sum>1.1) return true;
  }

  return false;
}

const SheduleDay = props => {
  const { shift, schd, timezone, onClickAdd, onClickEdit } = props;

  const classes = useStyles();

  const check = useMemo(() => checkSchedule(schd, timezone), [schd, timezone]);

  //это сегодня (в часовом поясе Помещения)
  const isTodayRoom = moment.unix(shift).utcOffset(timezone).isSame(moment().utcOffset(timezone).startOf('day'));

  //это сегодня (в локальном часовом поясе)
  //const isToday = moment.unix(shift).isSame(moment().startOf('day'));

  const btnDisabled=moment.unix(shift).utcOffset(timezone).isSameOrBefore(moment().utcOffset(timezone).startOf('day'));

  return (

    <Paper variant="outlined" className={classes.root}>
      <SheduleDayHeader shift={shift} timezone={timezone} />
      <List dense className={classes.listRoot}>
        {schd.map((value,index) => (
          <div key={value.p + "-" + value.d1 + "-" + value.d2+ "-" + index}>
            <ListItem>
              <ListItemAvatar>
                <StaffAvatar guid={value.p} />
              </ListItemAvatar>
              <ListItemText
                secondary={<StaffName guid={value.p} />}
                primary={<>
                  <Typography
                    component="span"
                    variant="h5"
                    color={value.r ? "error" : "textPrimary"}
                  >
                    {moment.unix(value.d1).utcOffset(timezone).format("HH:mm")}
                    {" - "} 
                    {moment.unix(value.d2).utcOffset(timezone).format("HH:mm")}
                  </Typography>
                </>
                }
              />
              <ListItemSecondaryAction>
                <Tooltip title="Изменить" placement="right">
                  <>
                    <IconButton edge="end" onClick={() => onClickEdit(shift, value.r, value)} disabled={btnDisabled && !(value.r && isTodayRoom)}>
                      <EditIcon color={value.r && isTodayRoom ? "error" : "inherit"}/>
                    </IconButton>
                  </>
                </Tooltip>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider variant="inset" component="li" />
          </div>
        ))}
        <div className={classes.footer}>
          {check?
            <div className={classes.warningIcon}>
              <Tooltip title='Ошибка в графике' placement='right'>
                <WarningIcon fontSize='large' color='error' />
              </Tooltip>
            </div>
          :null}
              <IconButton className={classes.addbutton} onClick={() => onClickAdd(shift, isTodayRoom)} disabled={btnDisabled && !isTodayRoom}>
                <Tooltip title="Добавить" placement="right">
                  <AddCircleOutlineIcon fontSize="large" color={isTodayRoom ? "error" : "inherit"} />
                </Tooltip>
              </IconButton>
        </div>
      </List>
    </Paper>
  );
};

SheduleDay.propTypes = {
  shift :PropTypes.number,
  schd: PropTypes.array,
  timezone: PropTypes.number,
  onClickAdd: PropTypes.func,
  onClickEdit: PropTypes.func
};

export default SheduleDay;
